import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48a1fc27"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-t"]
const _hoisted_2 = {
  key: 0,
  class: "album-list-total"
}
const _hoisted_3 = { class: "time" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "album-section-select" }, null, -1))
const _hoisted_5 = { class: "album-section-time" }
const _hoisted_6 = { class: "photo-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "video-duration"
}
const _hoisted_10 = {
  key: 2,
  class: "album-footer"
}

import {computed} from 'vue'
import { useAlbumStore } from '@remote/store/album'
import LoadMore from '@remote/components/LoadMore.vue'
import { IAlbumItem } from '@remote/type/album'
import {formatLastTime} from '@remote/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  inSubPath: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const {
  data,
  subPathData,
  loadMore,
  toggleSelected,
  toggleSelectedAll,
  previewAlbum,
} = useAlbumStore()

const dataSource = computed(() => props.inSubPath ? subPathData : data)
const hasSeleted = computed(() => {
  const dataSource = props.inSubPath ? subPathData : data
  return dataSource.selectedAll || Object.keys(dataSource.selectedMap).length > 0
})

const handleOnClickItem = (photo: IAlbumItem) => {
  if (hasSeleted.value) {
    toggleSelected(photo)
  } else {
    // 图片视频消费
    console.log('handleOnClickItem', photo)
    previewAlbum(photo)
  }
}


return (_ctx: any,_cache: any) => {
  const _directive_see = _resolveDirective("see")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["album-list", {'part-selected': _unref(hasSeleted)}]),
    "data-t": _unref(dataSource).pageToken
  }, [
    (_unref(dataSource).list?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass(["checkbox", {checked: _unref(dataSource).selectedAll}]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleSelectedAll) && _unref(toggleSelectedAll)(...args)))
          }, null, 2),
          _createElementVNode("span", null, "共" + _toDisplayString(_unref(dataSource).total) + "项", 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource).displayList, (list) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "album-date-item",
        key: list.id
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(list.date), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.imageList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "photo-item",
              key: item.md5sum,
              onClick: ($event: any) => (handleOnClickItem(item))
            }, [
              _createElementVNode("div", {
                class: "img-container img",
                style: _normalizeStyle({ background: `url(${item.cover})` })
              }, null, 4),
              _createElementVNode("div", {
                class: _normalizeClass(["check-btn", {checked: _unref(dataSource).selectedAll || _unref(dataSource).selectedMap[item.md5sum]}]),
                onClick: _withModifiers(($event: any) => (_unref(toggleSelected)(item)), ["stop"])
              }, null, 10, _hoisted_8),
              (item.media === 1 && item.duration && item.duration > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(formatLastTime)(item.duration)), 1))
                : _createCommentVNode("", true)
            ], 8, _hoisted_7))
          }), 128))
        ])
      ]))
    }), 128)),
    (!!_unref(dataSource).pageToken)
      ? _withDirectives((_openBlock(), _createBlock(LoadMore, {
          key: 1,
          onClick: _unref(loadMore)
        }, null, 8, ["onClick"])), [
          [_directive_see, _unref(loadMore)]
        ])
      : _createCommentVNode("", true),
    (_unref(dataSource).total > 15 && _unref(dataSource).list?.length >= _unref(dataSource).total && !_unref(dataSource).pageToken)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, " ——— 暂无更多数据 ——— "))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})